var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LMarker',{attrs:{"lat-lng":_vm.position}},[_c('LPopup',[_c('MapMarkerPosition',{attrs:{"position":_vm.position}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }